// source: query.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.cloud.CommentsOrder', null, global);
goog.exportSymbol('proto.cloud.CommentsSearchParameters', null, global);
goog.exportSymbol('proto.cloud.EntitiesOrder', null, global);
goog.exportSymbol('proto.cloud.EntitiesSearchParameters', null, global);
goog.exportSymbol('proto.cloud.JobsOrder', null, global);
goog.exportSymbol('proto.cloud.JobsSearchParameters', null, global);
goog.exportSymbol('proto.cloud.MetadataOrder', null, global);
goog.exportSymbol('proto.cloud.QueryBool', null, global);
goog.exportSymbol('proto.cloud.QueryDate', null, global);
goog.exportSymbol('proto.cloud.QueryDate.OneOfQueryDateCase', null, global);
goog.exportSymbol('proto.cloud.QueryDate.Range', null, global);
goog.exportSymbol('proto.cloud.QueryDouble', null, global);
goog.exportSymbol('proto.cloud.QueryDouble.OneOfQueryDoubleCase', null, global);
goog.exportSymbol('proto.cloud.QueryDouble.Range', null, global);
goog.exportSymbol('proto.cloud.QueryInt64', null, global);
goog.exportSymbol('proto.cloud.QueryInt64.OneOfQueryInt64Case', null, global);
goog.exportSymbol('proto.cloud.QueryInt64.Range', null, global);
goog.exportSymbol('proto.cloud.QueryString', null, global);
goog.exportSymbol('proto.cloud.QueryString.OneOfQueryStringCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryString = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud.QueryString.oneofGroups_);
};
goog.inherits(proto.cloud.QueryString, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryString.displayName = 'proto.cloud.QueryString';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryInt64 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud.QueryInt64.oneofGroups_);
};
goog.inherits(proto.cloud.QueryInt64, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryInt64.displayName = 'proto.cloud.QueryInt64';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryInt64.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.QueryInt64.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryInt64.Range.displayName = 'proto.cloud.QueryInt64.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryDouble = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud.QueryDouble.oneofGroups_);
};
goog.inherits(proto.cloud.QueryDouble, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryDouble.displayName = 'proto.cloud.QueryDouble';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryDouble.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.QueryDouble.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryDouble.Range.displayName = 'proto.cloud.QueryDouble.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryBool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.QueryBool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryBool.displayName = 'proto.cloud.QueryBool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud.QueryDate.oneofGroups_);
};
goog.inherits(proto.cloud.QueryDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryDate.displayName = 'proto.cloud.QueryDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.QueryDate.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.QueryDate.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.QueryDate.Range.displayName = 'proto.cloud.QueryDate.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.CommentsSearchParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.CommentsSearchParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.CommentsSearchParameters.displayName = 'proto.cloud.CommentsSearchParameters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.EntitiesSearchParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.EntitiesSearchParameters.repeatedFields_, null);
};
goog.inherits(proto.cloud.EntitiesSearchParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.EntitiesSearchParameters.displayName = 'proto.cloud.EntitiesSearchParameters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobsSearchParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobsSearchParameters.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobsSearchParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobsSearchParameters.displayName = 'proto.cloud.JobsSearchParameters';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud.QueryString.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.cloud.QueryString.OneOfQueryStringCase = {
  ONE_OF_QUERY_STRING_NOT_SET: 0,
  SEARCH_STARTS_WITH: 1,
  SEARCH_EXACT: 2
};

/**
 * @return {proto.cloud.QueryString.OneOfQueryStringCase}
 */
proto.cloud.QueryString.prototype.getOneOfQueryStringCase = function() {
  return /** @type {proto.cloud.QueryString.OneOfQueryStringCase} */(jspb.Message.computeOneofCase(this, proto.cloud.QueryString.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryString.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryString.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryString.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchStartsWith: jspb.Message.getFieldWithDefault(msg, 1, ""),
    searchExact: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryString}
 */
proto.cloud.QueryString.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryString;
  return proto.cloud.QueryString.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryString}
 */
proto.cloud.QueryString.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchStartsWith(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchExact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryString.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryString.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryString.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string search_starts_with = 1;
 * @return {string}
 */
proto.cloud.QueryString.prototype.getSearchStartsWith = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.QueryString} returns this
 */
proto.cloud.QueryString.prototype.setSearchStartsWith = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.cloud.QueryString.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud.QueryString} returns this
 */
proto.cloud.QueryString.prototype.clearSearchStartsWith = function() {
  return jspb.Message.setOneofField(this, 1, proto.cloud.QueryString.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryString.prototype.hasSearchStartsWith = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string search_exact = 2;
 * @return {string}
 */
proto.cloud.QueryString.prototype.getSearchExact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.QueryString} returns this
 */
proto.cloud.QueryString.prototype.setSearchExact = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryString.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud.QueryString} returns this
 */
proto.cloud.QueryString.prototype.clearSearchExact = function() {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryString.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryString.prototype.hasSearchExact = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud.QueryInt64.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.cloud.QueryInt64.OneOfQueryInt64Case = {
  ONE_OF_QUERY_INT64_NOT_SET: 0,
  SEARCH_RANGE: 1,
  SEARCH_EXACT: 2
};

/**
 * @return {proto.cloud.QueryInt64.OneOfQueryInt64Case}
 */
proto.cloud.QueryInt64.prototype.getOneOfQueryInt64Case = function() {
  return /** @type {proto.cloud.QueryInt64.OneOfQueryInt64Case} */(jspb.Message.computeOneofCase(this, proto.cloud.QueryInt64.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryInt64.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryInt64.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryInt64} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryInt64.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchRange: (f = msg.getSearchRange()) && proto.cloud.QueryInt64.Range.toObject(includeInstance, f),
    searchExact: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryInt64}
 */
proto.cloud.QueryInt64.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryInt64;
  return proto.cloud.QueryInt64.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryInt64} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryInt64}
 */
proto.cloud.QueryInt64.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.QueryInt64.Range;
      reader.readMessage(value,proto.cloud.QueryInt64.Range.deserializeBinaryFromReader);
      msg.setSearchRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSearchExact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryInt64.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryInt64.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryInt64} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryInt64.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.QueryInt64.Range.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryInt64.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryInt64.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryInt64.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryInt64.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    finish: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryInt64.Range}
 */
proto.cloud.QueryInt64.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryInt64.Range;
  return proto.cloud.QueryInt64.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryInt64.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryInt64.Range}
 */
proto.cloud.QueryInt64.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryInt64.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryInt64.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryInt64.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryInt64.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFinish();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.cloud.QueryInt64.Range.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryInt64.Range} returns this
 */
proto.cloud.QueryInt64.Range.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 finish = 2;
 * @return {number}
 */
proto.cloud.QueryInt64.Range.prototype.getFinish = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryInt64.Range} returns this
 */
proto.cloud.QueryInt64.Range.prototype.setFinish = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Range search_range = 1;
 * @return {?proto.cloud.QueryInt64.Range}
 */
proto.cloud.QueryInt64.prototype.getSearchRange = function() {
  return /** @type{?proto.cloud.QueryInt64.Range} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryInt64.Range, 1));
};


/**
 * @param {?proto.cloud.QueryInt64.Range|undefined} value
 * @return {!proto.cloud.QueryInt64} returns this
*/
proto.cloud.QueryInt64.prototype.setSearchRange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.cloud.QueryInt64.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.QueryInt64} returns this
 */
proto.cloud.QueryInt64.prototype.clearSearchRange = function() {
  return this.setSearchRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryInt64.prototype.hasSearchRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 search_exact = 2;
 * @return {number}
 */
proto.cloud.QueryInt64.prototype.getSearchExact = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryInt64} returns this
 */
proto.cloud.QueryInt64.prototype.setSearchExact = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryInt64.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud.QueryInt64} returns this
 */
proto.cloud.QueryInt64.prototype.clearSearchExact = function() {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryInt64.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryInt64.prototype.hasSearchExact = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud.QueryDouble.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.cloud.QueryDouble.OneOfQueryDoubleCase = {
  ONE_OF_QUERY_DOUBLE_NOT_SET: 0,
  SEARCH_RANGE: 1,
  SEARCH_EXACT: 2
};

/**
 * @return {proto.cloud.QueryDouble.OneOfQueryDoubleCase}
 */
proto.cloud.QueryDouble.prototype.getOneOfQueryDoubleCase = function() {
  return /** @type {proto.cloud.QueryDouble.OneOfQueryDoubleCase} */(jspb.Message.computeOneofCase(this, proto.cloud.QueryDouble.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryDouble.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryDouble.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryDouble} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDouble.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchRange: (f = msg.getSearchRange()) && proto.cloud.QueryDouble.Range.toObject(includeInstance, f),
    searchExact: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryDouble}
 */
proto.cloud.QueryDouble.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryDouble;
  return proto.cloud.QueryDouble.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryDouble} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryDouble}
 */
proto.cloud.QueryDouble.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.QueryDouble.Range;
      reader.readMessage(value,proto.cloud.QueryDouble.Range.deserializeBinaryFromReader);
      msg.setSearchRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSearchExact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryDouble.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryDouble.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryDouble} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDouble.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.QueryDouble.Range.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeDouble(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryDouble.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryDouble.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryDouble.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDouble.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    finish: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryDouble.Range}
 */
proto.cloud.QueryDouble.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryDouble.Range;
  return proto.cloud.QueryDouble.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryDouble.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryDouble.Range}
 */
proto.cloud.QueryDouble.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFinish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryDouble.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryDouble.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryDouble.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDouble.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getFinish();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double start = 1;
 * @return {number}
 */
proto.cloud.QueryDouble.Range.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryDouble.Range} returns this
 */
proto.cloud.QueryDouble.Range.prototype.setStart = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double finish = 2;
 * @return {number}
 */
proto.cloud.QueryDouble.Range.prototype.getFinish = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryDouble.Range} returns this
 */
proto.cloud.QueryDouble.Range.prototype.setFinish = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional Range search_range = 1;
 * @return {?proto.cloud.QueryDouble.Range}
 */
proto.cloud.QueryDouble.prototype.getSearchRange = function() {
  return /** @type{?proto.cloud.QueryDouble.Range} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryDouble.Range, 1));
};


/**
 * @param {?proto.cloud.QueryDouble.Range|undefined} value
 * @return {!proto.cloud.QueryDouble} returns this
*/
proto.cloud.QueryDouble.prototype.setSearchRange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.cloud.QueryDouble.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.QueryDouble} returns this
 */
proto.cloud.QueryDouble.prototype.clearSearchRange = function() {
  return this.setSearchRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryDouble.prototype.hasSearchRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double search_exact = 2;
 * @return {number}
 */
proto.cloud.QueryDouble.prototype.getSearchExact = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.QueryDouble} returns this
 */
proto.cloud.QueryDouble.prototype.setSearchExact = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryDouble.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud.QueryDouble} returns this
 */
proto.cloud.QueryDouble.prototype.clearSearchExact = function() {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryDouble.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryDouble.prototype.hasSearchExact = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryBool.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryBool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryBool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryBool.toObject = function(includeInstance, msg) {
  var f, obj = {
    truthy: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryBool}
 */
proto.cloud.QueryBool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryBool;
  return proto.cloud.QueryBool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryBool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryBool}
 */
proto.cloud.QueryBool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTruthy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryBool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryBool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryBool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryBool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTruthy();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool truthy = 1;
 * @return {boolean}
 */
proto.cloud.QueryBool.prototype.getTruthy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.QueryBool} returns this
 */
proto.cloud.QueryBool.prototype.setTruthy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud.QueryDate.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.cloud.QueryDate.OneOfQueryDateCase = {
  ONE_OF_QUERY_DATE_NOT_SET: 0,
  SEARCH_RANGE: 1,
  SEARCH_EXACT: 2
};

/**
 * @return {proto.cloud.QueryDate.OneOfQueryDateCase}
 */
proto.cloud.QueryDate.prototype.getOneOfQueryDateCase = function() {
  return /** @type {proto.cloud.QueryDate.OneOfQueryDateCase} */(jspb.Message.computeOneofCase(this, proto.cloud.QueryDate.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryDate.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDate.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchRange: (f = msg.getSearchRange()) && proto.cloud.QueryDate.Range.toObject(includeInstance, f),
    searchExact: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryDate}
 */
proto.cloud.QueryDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryDate;
  return proto.cloud.QueryDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryDate}
 */
proto.cloud.QueryDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.QueryDate.Range;
      reader.readMessage(value,proto.cloud.QueryDate.Range.deserializeBinaryFromReader);
      msg.setSearchRange(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchExact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.QueryDate.Range.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.QueryDate.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.QueryDate.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.QueryDate.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDate.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, ""),
    finish: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.QueryDate.Range}
 */
proto.cloud.QueryDate.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.QueryDate.Range;
  return proto.cloud.QueryDate.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.QueryDate.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.QueryDate.Range}
 */
proto.cloud.QueryDate.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.QueryDate.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.QueryDate.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.QueryDate.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.QueryDate.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFinish();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string start = 1;
 * @return {string}
 */
proto.cloud.QueryDate.Range.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.QueryDate.Range} returns this
 */
proto.cloud.QueryDate.Range.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string finish = 2;
 * @return {string}
 */
proto.cloud.QueryDate.Range.prototype.getFinish = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.QueryDate.Range} returns this
 */
proto.cloud.QueryDate.Range.prototype.setFinish = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Range search_range = 1;
 * @return {?proto.cloud.QueryDate.Range}
 */
proto.cloud.QueryDate.prototype.getSearchRange = function() {
  return /** @type{?proto.cloud.QueryDate.Range} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryDate.Range, 1));
};


/**
 * @param {?proto.cloud.QueryDate.Range|undefined} value
 * @return {!proto.cloud.QueryDate} returns this
*/
proto.cloud.QueryDate.prototype.setSearchRange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.cloud.QueryDate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.QueryDate} returns this
 */
proto.cloud.QueryDate.prototype.clearSearchRange = function() {
  return this.setSearchRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryDate.prototype.hasSearchRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string search_exact = 2;
 * @return {string}
 */
proto.cloud.QueryDate.prototype.getSearchExact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.QueryDate} returns this
 */
proto.cloud.QueryDate.prototype.setSearchExact = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryDate.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud.QueryDate} returns this
 */
proto.cloud.QueryDate.prototype.clearSearchExact = function() {
  return jspb.Message.setOneofField(this, 2, proto.cloud.QueryDate.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.QueryDate.prototype.hasSearchExact = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.CommentsSearchParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.CommentsSearchParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.CommentsSearchParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CommentsSearchParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldOr: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    userId: (f = msg.getUserId()) && proto.cloud.QueryString.toObject(includeInstance, f),
    dateSearch: (f = msg.getDateSearch()) && proto.cloud.QueryDate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.CommentsSearchParameters}
 */
proto.cloud.CommentsSearchParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.CommentsSearchParameters;
  return proto.cloud.CommentsSearchParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.CommentsSearchParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.CommentsSearchParameters}
 */
proto.cloud.CommentsSearchParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldOr(value);
      break;
    case 5:
      var value = new proto.cloud.QueryString;
      reader.readMessage(value,proto.cloud.QueryString.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 6:
      var value = new proto.cloud.QueryDate;
      reader.readMessage(value,proto.cloud.QueryDate.deserializeBinaryFromReader);
      msg.setDateSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.CommentsSearchParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.CommentsSearchParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.CommentsSearchParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CommentsSearchParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldOr();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.cloud.QueryString.serializeBinaryToWriter
    );
  }
  f = message.getDateSearch();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.cloud.QueryDate.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool should_or = 1;
 * @return {boolean}
 */
proto.cloud.CommentsSearchParameters.prototype.getShouldOr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.CommentsSearchParameters} returns this
 */
proto.cloud.CommentsSearchParameters.prototype.setShouldOr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional QueryString user_id = 5;
 * @return {?proto.cloud.QueryString}
 */
proto.cloud.CommentsSearchParameters.prototype.getUserId = function() {
  return /** @type{?proto.cloud.QueryString} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryString, 5));
};


/**
 * @param {?proto.cloud.QueryString|undefined} value
 * @return {!proto.cloud.CommentsSearchParameters} returns this
*/
proto.cloud.CommentsSearchParameters.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.CommentsSearchParameters} returns this
 */
proto.cloud.CommentsSearchParameters.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.CommentsSearchParameters.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional QueryDate date_search = 6;
 * @return {?proto.cloud.QueryDate}
 */
proto.cloud.CommentsSearchParameters.prototype.getDateSearch = function() {
  return /** @type{?proto.cloud.QueryDate} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryDate, 6));
};


/**
 * @param {?proto.cloud.QueryDate|undefined} value
 * @return {!proto.cloud.CommentsSearchParameters} returns this
*/
proto.cloud.CommentsSearchParameters.prototype.setDateSearch = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.CommentsSearchParameters} returns this
 */
proto.cloud.CommentsSearchParameters.prototype.clearDateSearch = function() {
  return this.setDateSearch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.CommentsSearchParameters.prototype.hasDateSearch = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.EntitiesSearchParameters.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.EntitiesSearchParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.EntitiesSearchParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.EntitiesSearchParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntitiesSearchParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldOr: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    entityChecksum: (f = msg.getEntityChecksum()) && proto.cloud.QueryString.toObject(includeInstance, f),
    entityName: (f = msg.getEntityName()) && proto.cloud.QueryString.toObject(includeInstance, f),
    entitySize: (f = msg.getEntitySize()) && proto.cloud.QueryInt64.toObject(includeInstance, f),
    entityType: (f = msg.getEntityType()) && proto.cloud.QueryInt64.toObject(includeInstance, f),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.EntitiesSearchParameters}
 */
proto.cloud.EntitiesSearchParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.EntitiesSearchParameters;
  return proto.cloud.EntitiesSearchParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.EntitiesSearchParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.EntitiesSearchParameters}
 */
proto.cloud.EntitiesSearchParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldOr(value);
      break;
    case 2:
      var value = new proto.cloud.QueryString;
      reader.readMessage(value,proto.cloud.QueryString.deserializeBinaryFromReader);
      msg.setEntityChecksum(value);
      break;
    case 3:
      var value = new proto.cloud.QueryString;
      reader.readMessage(value,proto.cloud.QueryString.deserializeBinaryFromReader);
      msg.setEntityName(value);
      break;
    case 4:
      var value = new proto.cloud.QueryInt64;
      reader.readMessage(value,proto.cloud.QueryInt64.deserializeBinaryFromReader);
      msg.setEntitySize(value);
      break;
    case 5:
      var value = new proto.cloud.QueryInt64;
      reader.readMessage(value,proto.cloud.QueryInt64.deserializeBinaryFromReader);
      msg.setEntityType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 7:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.EntitiesSearchParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.EntitiesSearchParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.EntitiesSearchParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntitiesSearchParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldOr();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEntityChecksum();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.QueryString.serializeBinaryToWriter
    );
  }
  f = message.getEntityName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud.QueryString.serializeBinaryToWriter
    );
  }
  f = message.getEntitySize();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.QueryInt64.serializeBinaryToWriter
    );
  }
  f = message.getEntityType();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.cloud.QueryInt64.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional bool should_or = 1;
 * @return {boolean}
 */
proto.cloud.EntitiesSearchParameters.prototype.getShouldOr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.setShouldOr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional QueryString entity_checksum = 2;
 * @return {?proto.cloud.QueryString}
 */
proto.cloud.EntitiesSearchParameters.prototype.getEntityChecksum = function() {
  return /** @type{?proto.cloud.QueryString} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryString, 2));
};


/**
 * @param {?proto.cloud.QueryString|undefined} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
*/
proto.cloud.EntitiesSearchParameters.prototype.setEntityChecksum = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearEntityChecksum = function() {
  return this.setEntityChecksum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.EntitiesSearchParameters.prototype.hasEntityChecksum = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional QueryString entity_name = 3;
 * @return {?proto.cloud.QueryString}
 */
proto.cloud.EntitiesSearchParameters.prototype.getEntityName = function() {
  return /** @type{?proto.cloud.QueryString} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryString, 3));
};


/**
 * @param {?proto.cloud.QueryString|undefined} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
*/
proto.cloud.EntitiesSearchParameters.prototype.setEntityName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearEntityName = function() {
  return this.setEntityName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.EntitiesSearchParameters.prototype.hasEntityName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional QueryInt64 entity_size = 4;
 * @return {?proto.cloud.QueryInt64}
 */
proto.cloud.EntitiesSearchParameters.prototype.getEntitySize = function() {
  return /** @type{?proto.cloud.QueryInt64} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryInt64, 4));
};


/**
 * @param {?proto.cloud.QueryInt64|undefined} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
*/
proto.cloud.EntitiesSearchParameters.prototype.setEntitySize = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearEntitySize = function() {
  return this.setEntitySize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.EntitiesSearchParameters.prototype.hasEntitySize = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QueryInt64 entity_type = 5;
 * @return {?proto.cloud.QueryInt64}
 */
proto.cloud.EntitiesSearchParameters.prototype.getEntityType = function() {
  return /** @type{?proto.cloud.QueryInt64} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryInt64, 5));
};


/**
 * @param {?proto.cloud.QueryInt64|undefined} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
*/
proto.cloud.EntitiesSearchParameters.prototype.setEntityType = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearEntityType = function() {
  return this.setEntityType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.EntitiesSearchParameters.prototype.hasEntityType = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string tags = 6;
 * @return {!Array<string>}
 */
proto.cloud.EntitiesSearchParameters.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * map<string, string> metadata = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.cloud.EntitiesSearchParameters.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.EntitiesSearchParameters} returns this
 */
proto.cloud.EntitiesSearchParameters.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobsSearchParameters.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobsSearchParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobsSearchParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobsSearchParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobsSearchParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldOr: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    jobDateFinished: (f = msg.getJobDateFinished()) && proto.cloud.QueryDate.toObject(includeInstance, f),
    jobName: (f = msg.getJobName()) && proto.cloud.QueryString.toObject(includeInstance, f),
    jobCountBytes: (f = msg.getJobCountBytes()) && proto.cloud.QueryInt64.toObject(includeInstance, f),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobsSearchParameters}
 */
proto.cloud.JobsSearchParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobsSearchParameters;
  return proto.cloud.JobsSearchParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobsSearchParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobsSearchParameters}
 */
proto.cloud.JobsSearchParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldOr(value);
      break;
    case 2:
      var value = new proto.cloud.QueryDate;
      reader.readMessage(value,proto.cloud.QueryDate.deserializeBinaryFromReader);
      msg.setJobDateFinished(value);
      break;
    case 3:
      var value = new proto.cloud.QueryString;
      reader.readMessage(value,proto.cloud.QueryString.deserializeBinaryFromReader);
      msg.setJobName(value);
      break;
    case 4:
      var value = new proto.cloud.QueryInt64;
      reader.readMessage(value,proto.cloud.QueryInt64.deserializeBinaryFromReader);
      msg.setJobCountBytes(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobsSearchParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobsSearchParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobsSearchParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobsSearchParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldOr();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getJobDateFinished();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.QueryDate.serializeBinaryToWriter
    );
  }
  f = message.getJobName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud.QueryString.serializeBinaryToWriter
    );
  }
  f = message.getJobCountBytes();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.QueryInt64.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional bool should_or = 1;
 * @return {boolean}
 */
proto.cloud.JobsSearchParameters.prototype.getShouldOr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.setShouldOr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional QueryDate job_date_finished = 2;
 * @return {?proto.cloud.QueryDate}
 */
proto.cloud.JobsSearchParameters.prototype.getJobDateFinished = function() {
  return /** @type{?proto.cloud.QueryDate} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryDate, 2));
};


/**
 * @param {?proto.cloud.QueryDate|undefined} value
 * @return {!proto.cloud.JobsSearchParameters} returns this
*/
proto.cloud.JobsSearchParameters.prototype.setJobDateFinished = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.clearJobDateFinished = function() {
  return this.setJobDateFinished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobsSearchParameters.prototype.hasJobDateFinished = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional QueryString job_name = 3;
 * @return {?proto.cloud.QueryString}
 */
proto.cloud.JobsSearchParameters.prototype.getJobName = function() {
  return /** @type{?proto.cloud.QueryString} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryString, 3));
};


/**
 * @param {?proto.cloud.QueryString|undefined} value
 * @return {!proto.cloud.JobsSearchParameters} returns this
*/
proto.cloud.JobsSearchParameters.prototype.setJobName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.clearJobName = function() {
  return this.setJobName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobsSearchParameters.prototype.hasJobName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional QueryInt64 job_count_bytes = 4;
 * @return {?proto.cloud.QueryInt64}
 */
proto.cloud.JobsSearchParameters.prototype.getJobCountBytes = function() {
  return /** @type{?proto.cloud.QueryInt64} */ (
    jspb.Message.getWrapperField(this, proto.cloud.QueryInt64, 4));
};


/**
 * @param {?proto.cloud.QueryInt64|undefined} value
 * @return {!proto.cloud.JobsSearchParameters} returns this
*/
proto.cloud.JobsSearchParameters.prototype.setJobCountBytes = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.clearJobCountBytes = function() {
  return this.setJobCountBytes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobsSearchParameters.prototype.hasJobCountBytes = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string tags = 5;
 * @return {!Array<string>}
 */
proto.cloud.JobsSearchParameters.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobsSearchParameters} returns this
 */
proto.cloud.JobsSearchParameters.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * @enum {number}
 */
proto.cloud.CommentsOrder = {
  COMMENTS_DEFAULT_ORDER: 0,
  COMMENTS_COMMENT_DATE_ORDER: 1,
  COMMENTS_COMMENT_USER_ORDER: 2
};

/**
 * @enum {number}
 */
proto.cloud.EntitiesOrder = {
  ENTITIES_DEFAULT_ORDER: 0,
  ENTITIES_ENTITY_CHECKSUM_ORDER: 1,
  ENTITIES_ENTITY_NAME_ORDER: 2,
  ENTITIES_ENTITY_SIZE_ORDER: 3,
  ENTITIES_ENTITY_TYPE_ORDER: 4
};

/**
 * @enum {number}
 */
proto.cloud.MetadataOrder = {
  METADATA_DEFAULT_ORDER: 0,
  METADATA_METADATA_VALUE_ORDER: 1
};

/**
 * @enum {number}
 */
proto.cloud.JobsOrder = {
  JOBS_DEFAULT_ORDER: 0,
  JOBS_JOB_DATE_FINISHED_ORDER: 1,
  JOBS_JOB_NAME_ORDER: 2,
  JOBS_JOB_SIZE_ORDER: 3,
  JOBS_JOB_DATE_CREATED_ORDER: 4
};

goog.object.extend(exports, proto.cloud);
